import { Component, inject } from '@angular/core';
import { UserStateService } from '../../core/services/user.state.service';
import { NavigationComponent } from '../../layout/navigation/navigation.component';
import { TranslatePipe } from '@ngx-translate/core';
import { StorageStateService } from '../../core/services/storage-state.service';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'default-page',
  imports: [NavigationComponent, TranslatePipe, JsonPipe],
  templateUrl: './default-page.component.html',
})
export class DefaultPageComponent {
  protected readonly userStateService = inject(UserStateService);
  protected readonly storageStateService = inject(StorageStateService);
}
